/**
 * Tickets already taken on a saved listing, read from its start times' capacity and remaining
 * places. The wizard uses them to stop a guide deleting a start time or ticket type that bookings
 * point at (or switching the duration, which deletes every start time): the API accepts those
 * deletions and leaves the bookings pointing at nothing.
 *
 * A start time added in the wizard has no capacity yet, so it counts as nothing taken.
 */
const takenOf = ({ capacity, remaining } = {}) =>
  Number.isFinite(Number(capacity)) && Number.isFinite(Number(remaining)) ? Math.max(0, Number(capacity) - Number(remaining)) : 0

export const getSlotTicketsTaken = (slot) => (slot && !slot._destroy ? takenOf(slot) : 0)

export const getBookedSlots = (slots = []) => slots.filter((slot) => getSlotTicketsTaken(slot) > 0)

export const getTicketTypeTicketsTaken = (ticketTypeId, slots = []) =>
  slots
    .filter((slot) => !slot._destroy)
    .flatMap((slot) => slot.capacities || [])
    .filter((entry) => String(entry.ticket_type_id) === String(ticketTypeId))
    .reduce((sum, entry) => sum + takenOf(entry), 0)
